<template>
  <div>
    <div class="article-block d-column">
      <div class="article-list">
        <div class="module j-flex weight">
          <div v-if="currPrograma != ''" class="fs-xl module-title">
            {{ currPrograma
            }}<span class="fs-lg" style="font-weight: 500">（负责人）</span>
          </div>
          <div v-else class="fs-xl module-title">
            {{ title
            }}<span class="fs-lg" style="font-weight: 500">（负责人）</span>
          </div>
        </div>
      </div>
      <div
        class="d-column person"
        v-for="(item, index) in personData"
        :key="'table_' + index"
      >
        <div class="office fs-md">{{ item.office }}</div>
        <div class="d-flex">
          <div class="person-info">
            <table>
              <tr>
                <td class="td-1">姓名</td>
                <td class="td-2">{{ item.name }}</td>
              </tr>
              <tr>
                <td class="td-1">主要工作</td>
                <td class="td-2">{{ item.job }}</td>
              </tr>
              <tr>
                <td class="td-1">联系电话</td>
                <td class="td-2">{{ item.tel }}</td>
              </tr>
              <tr>
                <td class="td-1">电子邮箱</td>
                <td class="td-2">{{ item.email }}</td>
              </tr>
              <tr>
                <td class="td-1">办公地点</td>
                <td class="td-2">{{ item.address }}</td>
              </tr>
            </table>
          </div>
          <div class="person-img">
            <img :src="getTearcherImg(item)" @error="headError" />
            <div class="img-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPartyGov } from '@/api/api'
export default {
  props: ['asideTitle', 'title', 'currPrograma'],
  data() {
    return {
      personData: {},
    }
  },
  created() {
    this.getInfo()
  },
  watch: {
    currPrograma: {
      handler() {
        this.getInfo()
      },
    },
  },
  computed: {
    getTearcherImg() {
      return function (item) {
        if (item.coverFile == null || item.coverFile == '') {
          if (this.personData.gender == '女') {
            return require('@/assets/img/default2.png')
          } else {
            return require('@/assets/img/default.png')
          }
        } else {
          return item.coverFile.path
        }
      }
    },
  },
  methods: {
    headError(e) {
      e.target.src = require('@/assets/img/default.png')
    },
    getInfo() {
      getPartyGov(this.currPrograma).then((res) => {
        if (res.data.statusCode == 1) {
          this.personData = res.data.obj
          console.log(res)
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/main.scss';
table,
table tr th,
table tr td {
  border: 1px solid #d1d1d1;
}
table {
  border-collapse: collapse;
  padding: 2px;
}
.td-1 {
  width: 88px;
  height: 36px;
  text-align: center;
  background-color: #e8e8e8;
}
.td-2 {
  width: 432px;
  height: 20px;
  padding: 8px 16px;
}
.article-block {
  width: 692px;
  min-height: 548px;
  background-color: #fff;
  padding: 24px 64px;
}
.module {
  line-height: 34px;
  padding-bottom: 8px;
  color: $titleFont;
}
.person-info {
  width: 520px;
}
.person {
  margin-top: 10px;
}
.person-img {
  margin-left: 24px;
  width: 150px;
  height: 200px;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  img {
    // width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    // left: 0;
  }
  .img-name {
    width: 100%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    background: rgba(24, 24, 24, 0.5);
    position: absolute;
    color: #fff;
    font-size: 15px;
    left: 0;
    bottom: 0;
  }
}
.office {
  font-weight: bold;
  padding: 8px 0;
}
</style>
